// ts-check
import { useQuery } from '@tanstack/react-query';
import useAPI from 'services/useAPI';
import createQueryRequest from 'services/createQueryRequest';


export const providerKeys = {
  all: ['providers'],
  providers: () => [...providerKeys.all],
  provider: (id) => [...providerKeys.providers(), id]
};

export const providerClientKeys = {
  all: ['providerClients'],
  clients: (providerId) => [...providerClientKeys.all, providerId],
  client: (providerId, id) => [...providerClientKeys.clients(), providerId, id]
};

export const useProviderClients = (providerId) => {
  const api = useAPI();
  const query = useQuery({
    queryKey: providerClientKeys.clients(providerId),
    queryFn: createQueryRequest(api.core.getProviderClients),
    enabled: !!providerId
  });
  return {
    query,
    providerClients: query.data,
    isLoading: query.isLoading
  };
};

export const useProviderClient = (providerId, providerClientId) => {
  const api = useAPI();
  const query = useQuery({
    queryKey: providerClientKeys.client(providerId, providerClientId),
    queryFn: ({ signal }) => {
      return api.core.getProviderClient(signal, providerId, providerClientId);
    },
    enabled: !!providerId && !!providerClientId
  });
  return {
    query,
    providerClient: query.data,
    isLoading: query.isLoading
  };
};

export const useProviders = () => {
  const api = useAPI();
  const query = useQuery({
    queryKey: providerKeys.providers(),
    queryFn: createQueryRequest(api.core.getProviders)
  });
  return {
    query,
    providers: query.data,
    isLoading: query.isLoading
  };
};

export const useProvider = (providerId, includeClients = false) => {
  const api = useAPI();
  const query = useQuery({
    queryKey: providerKeys.provider(providerId),
    queryFn: ({ signal }) => {
      return api.core.getProvider(signal, providerId);
    },
    enabled: !!providerId
  });
  const { providerClients, isLoading } = useProviderClients(includeClients === true ? providerId : null);

  return {
    query,
    provider: query.data,
    isLoading: query.isLoading,
    providerClients: includeClients === true ? providerClients : null,
    isLoadingProviderClients: includeClients === true ? isLoading : null
  };
};

